module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app"
  }, [_c('scroll', {
    staticClass: "report-detail",
    on: {
      "refresh": _vm.refresh
    }
  }, [_c('div', {
    staticClass: "report-detail-title icon-msg-h"
  }, [_c('span', {
    staticClass: "icon report-item-img"
  }), _vm._v(" "), _c('div', {
    staticClass: "f-largest"
  }, [_vm._v(_vm._s(_vm.queryParam.examItem))])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.qrcodeEnable),
      expression: "qrcodeEnable"
    }],
    staticClass: "report-detail-qrcode thick"
  }, [_c('p', [_vm._v("打印报告二维码")]), _vm._v(" "), _c('section', {
    staticClass: "thick",
    staticStyle: {
      "margin-top": "40px"
    }
  }, [_c('qrcode', {
    staticClass: "qrcode",
    attrs: {
      "size": 171,
      "cls": _vm.qrCls,
      "value": _vm.qrText
    }
  }), _vm._v(" "), _c('o2o-helper', {
    attrs: {
      "type": 0
    }
  })], 1)]), _vm._v(" "), _c('section', {
    staticClass: "thick"
  }, [_c('dl', {
    staticClass: "field"
  }, [_c('dd', [_vm._v(_vm._s(_vm.examDetail.hospitalName))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("卡号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.examDetail.cardNo))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("报告单号")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.queryParam.examId))])]), _vm._v(" "), _c('dl', {
    staticClass: "field"
  }, [_c('dt', [_vm._v("出单时间")]), _vm._v(" "), _c('dd', [_vm._v(_vm._s(_vm.queryParam.examTime))])])]), _vm._v(" "), _vm._l((_vm.examDetail.items), function(item, index) {
    return _c('section', {
      staticClass: "thick",
      on: {
        "click": function($event) {
          return _vm.showDetail(item)
        }
      }
    }, [_c('div', {
      staticClass: "title f-strong"
    }, [_c('div', {
      staticStyle: {
        "width": "90%",
        "display": "inline-block"
      }
    }, [_vm._v(_vm._s(item.examItem))]), _vm._v(" "), (!item.showDetailInfo) ? _c('span', {
      staticClass: "arr-gray-down"
    }) : _vm._e(), _vm._v(" "), (item.showDetailInfo) ? _c('span', {
      staticClass: "arr-gray-up"
    }) : _vm._e()]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.showDetailInfo),
        expression: "item.showDetailInfo"
      }],
      staticStyle: {
        "background": "#f8f8f8"
      }
    }, [_c('dl', {
      staticClass: "field"
    }, [_c('dt', [_vm._v("检查部位")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('dd', [_vm._v(_vm._s(item.examPart))])]), _vm._v(" "), _c('dl', {
      staticClass: "field"
    }, [_c('dt', [_vm._v("检查所见")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('dd', [_vm._v(_vm._s(item.examView))])]), _vm._v(" "), _c('div', {
      staticClass: "field"
    }, [_c('span', {
      staticClass: "f-minor"
    }, [_vm._v("诊疗意见及建议")])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('dd', [_vm._v(_vm._s(item.diagnosis))])])])])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70f2dcd9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/myreport/ExamDetail.vue
// module id = 849
// module chunks = 0